var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"card",on:{"click":_vm.notify}},[_c('p',{staticClass:"btn-msg"},[_vm._v(_vm._s(this.buttonText))]),_c('v-icon',{attrs:{"size":"40"}},[_vm._v(" mdi-chevron-right ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }